export default "__VITE_ASSET__de2a8653__"